import { pick } from 'ramda';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'js/hooks/navigate';
import { eqListProps } from 'js/utils/methods.util';

import * as helpers from '../helpers';
import { FB_PARAMS_TO_REMOVE } from '../constants';

export const useClearUrl = () => {
    const location = useLocation();
    const navigateWithReplace = useNavigate({ replace: true });

    return useCallback(() => {
        const cleanUrl = new URL(helpers.getCleanUrl());
        const locationProps = ['pathname', 'search', 'hash'];

        if (!eqListProps(locationProps, location, cleanUrl)) {
            navigateWithReplace(
                pick(locationProps, cleanUrl),
                location.state,
                { removeParams: FB_PARAMS_TO_REMOVE }
            );
        }

    }, [location, navigateWithReplace]);
};

